<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'App',
  watch: {
    currentUserRoleInfo (rol) {
      if (rol !== 'mro_admin') {
        this.$router.push({name: 'error'})
        setTimeout(async () => {
          this.$message({
            type: 'info',
            message: 'No se encuentra autorizado para acceder al administrador, comuniquese con el administrador'
          })
          this.$store.dispatch('auth/logout')
        }, 100)
      }
    }
  },
  computed: {
    ...mapGetters('auth', [
      'isAuthenticated',
      'currentUser',
      'currentUserRoleInfo'
    ])
  },
  beforeCreate () {
    this.$store.dispatch('auth/assignRoutes')
  },
  created () {
    this.isAuthenticated.then(async (userInfo) => {
      if (userInfo && !this.currentUser) {
        await this.$store.dispatch('auth/setCurrentUser', userInfo)
        await this.$store.dispatch('auth/getUserProfile')

        const redirectPath = window.localStorage.getItem('auth:redirect')
        if (redirectPath) {
          window.localStorage.removeItem('auth:redirect')
          this.$router.push({
            path: redirectPath
          })
        }
      }
    })
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue